import React from 'react'
import { createUseStyles } from 'react-jss'
import AccordionItem from './atoms/AccordionItem'
import SVG from '../ui/SVG/SVG'
import obj2Arr from '../../utils/obj2Arr'

const useStyles = createUseStyles(theme => ({
  accCntainer: {
    padding: '45px 0',
    margin: '0 auto',
    width: '100%',
    maxWidth: '1200px',
    '& > div': {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gridGap: '30px',
      '@media (max-width: 1200px)': {
        boxSizing: 'border-box',
        padding: '45px 15px',
      },
      '@media (max-width: 700px)': {
        gridTemplateColumns: '1fr',
        gridGap: '0',
        boxSizing: 'border-box',
        padding: '45px 15px',
      },
    },
  },
  accTitle: {
    fontSize: '26px',
    lineHeight: '32px',
    marginBottom: '30px',
    marginTop: '10px',
    fontWeight: 700,
    '& a': {
      color: '#000',
      textDecoration: 'none',
      '& span:nth-child(2)': {
        display: 'none',
        marginLeft: 10,
      },
      '&:hover': {
        textDecoration: 'none',
        color: theme.colors.main,
        // '& span:nth-child(2)': {
        //   display: 'inline-flex',
        // },
      },
    },
  },
  selected: {
    color: `${theme.colors.main} !important`,
    '& span:nth-child(2)': {
      display: 'inline-flex !important',
    },
  },
  accDetails: {
    '& p': {
      fontSize: '16px',
      lineHeight: '24px',
      letterSpacing: '0.02em',
    },
  },
  icon: {
    backgroundColor: theme.colors.main,
    marginLeft: 'auto',
    borderRadius: '50%',
    width: '24px',
    height: '24px',
    fill: theme.colors.white,
    color: theme.colors.white,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
}))

const AccordionGroup = props => {
  const { backgroundcoloron, items } = props
  const classes = useStyles()

  const objArr = obj2Arr(items)

  const [questions, setQuestions] = React.useState(obj2Arr(objArr[0].accordions))
  const [selected, setSelected] = React.useState(0)

  const changeQuestions = (e, i) => {
    e.preventDefault()
    setQuestions(objArr[i].accordions)
    setSelected(i)
  }

  return (
    <div style={{ backgroundColor: backgroundcoloron == '1' ? '#F0F8FF' : '' }}>
      <div className={classes.accCntainer}>
        <div>
          <div>
            {objArr &&
              objArr.map((item, i) => (
                <div key={`titles${i}`} className={classes.accTitle}>
                  <a
                    href="#"
                    onClick={e => changeQuestions(e, i)}
                    className={selected == i ? classes.selected : ''}
                  >
                    <span>{item.title}</span>
                    <span className={classes.icon}>
                      <SVG name={'Chevron'} width={15} height={15} />
                    </span>
                  </a>
                </div>
              ))}
          </div>
          <div>
            <div>
              {questions &&
                obj2Arr(questions).map(({ title, body, state }) => (
                  <AccordionItem key={title} title={title} body={body} state={state} />
                ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AccordionGroup
